import { render } from "./ProductsList.vue?vue&type=template&id=0b1b1088"
import script from "./ProductsList.vue?vue&type=script&lang=js"
export * from "./ProductsList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__